module.exports = __webpack_public_path__ + "static/media/network_list_item_icon.217e9c02.svg";